<template>
  <v-card :loading="loading" :disabled="loading" flat class="pa-2">
    <v-tabs v-model="tab">
      <v-tabs-slider color="primary"></v-tabs-slider>
      <v-tab> {{ $t("all") }} </v-tab>
      <v-tab class="my-1" v-for="(cat, i) in category" :key="i">{{
        cat
      }}</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <v-card-subtitle v-if="selectedFile?.length >= maxChoseLength">
          {{ $t("max_files_limit", { count: persian(maxChoseLength) }) }}
        </v-card-subtitle>
        <v-row class="pa-2" v-if="audios.length > 0">
          <v-col v-for="(sound, i) in audios" :key="i" cols="12" md="4" xl="6">
            <v-card
              id="music_card"
              class="border border-lg"
              :style="{
                border: selectedFile.find((item) => item == sound.id)
                  ? '2px solid var(--v-primary-base) !important'
                  : null,
              }"
              :disabled="
                selectedFile?.length >= maxChoseLength &&
                !selectedFile.some((i) => i === sound.id)
              "
            >
              <v-checkbox
                class="mt-2 mr-2"
                v-model="selectedFile"
                :value="sound.id"
                multiple
              ></v-checkbox>
              <audio-player
                height="170"
                :audioSound="false"
                :flat="true"
                :file="sound.full_path"
                :title="sound.title"
                :id="sound.id"
              />
            </v-card>
          </v-col>
        </v-row>
        <span class="d-flex w-100 justify-content-center" v-else>
          <v-card-subtitle> {{ $t("no_audio_in_category") }}</v-card-subtitle>
        </span>
      </v-tab-item>
      <v-tab-item v-for="(cat, i) in category" :key="i">
        <v-card-subtitle v-if="selectedFile?.length >= maxChoseLength">
          {{ $t("max_files_limit", { count: persian(maxChoseLength) }) }}
        </v-card-subtitle>
        <v-row class="pa-2" v-if="findCategoryFile(cat).length > 0">
          <v-col
            v-for="(sound, i) in findCategoryFile(cat)"
            :key="i"
            cols="12"
            md="6"
            xl="4"
          >
            <v-card
              :disabled="
                selectedFile?.length >= maxChoseLength &&
                !selectedFile.some((i) => i === sound.id)
              "
              id="music_card"
              class="border border-lg"
              :style="{
                border: selectedFile.find((item) => item == sound.id)
                  ? '2px solid var(--v-primary-base) !important'
                  : null,
              }"
            >
              <v-checkbox
                class="mt-2 mr-2"
                v-model="selectedFile"
                :value="sound.id"
                multiple
              ></v-checkbox>
              <audio-player
                height="170"
                :audioSound="false"
                :flat="true"
                :file="sound.full_path"
                :id="sound.id"
                :title="sound.title"
              />
            </v-card>
          </v-col>
        </v-row>
        <span class="d-flex w-100 justify-content-center" v-else>
          <v-card-subtitle> {{ $t("no_audio_in_category") }}</v-card-subtitle>
        </span>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import audioPlayer from "./audioPlayer.vue";
export default {
  components: { audioPlayer },
  name: "audioList",
  props: {
    category: Array,
    audios: Array,
    value: Array,
    loading: Boolean,
    audioSelects: [Array],
    dialog: [Boolean],
  },
  data() {
    return {
      tab: null,
      merged: [],
    };
  },

  computed: {
    selectedFile: {
      get() {
        return this.value.map((item) => item.id);
      },
      set(val) {
        const selectedFromAllSounds = this.audios.filter((s) =>
          val.includes(s.id),
        );

        const oldItems = this.value || [];

        const missingItems = oldItems.filter(
          (old) => !this.audios.some((s) => s.id === old.id),
        );

        const finalList = [...selectedFromAllSounds, ...missingItems];

        this.$emit("input", finalList);
      },
    },
  },

  watch: {
    selectedFile: {
      deep: true,
      immediate: true,
      handler(val) {},
    },
  },

  mounted() {},

  inject: {
    maxChoseLength: { default: 9999 },
  },

  methods: {
    findCategoryFile(cat) {
      let audio = [];
      this.audios.map((item) => {
        if (item.category.includes(cat)) {
          audio.push(item);
        }
      });
      return audio;
    },
  },
};
</script>

<style></style>
